export default {
    created: function() {
        for (var i = 1; i <= 10; i++) {
            this.amountOptions.push(i);
        }
        let token = document.head.querySelector('meta[name="csrf-token"]');
        this.token = token.content;

        if (this.orderLine !== undefined) {
            this.shape = this.orderLine.shape_code;
            this.length = this.orderLine.length;
            this.width = this.orderLine.width;
            this.radius = this.orderLine.thickness;
            this.thickness = this.orderLine.thickness;
        }
    },
    mounted: function() {
        if (localStorage.getItem('guestShoppingcart')) {
            this.guestOrderLines = JSON.parse(localStorage.getItem('guestShoppingcart'));
        }
    },
    methods: {
        sendForm: function() {
            let _this = this;
            let elementFound = 0;

            let params = [
                _this,
                0
            ];

            if (this.guestOrderLines.length > 0) {
                this.guestOrderLines.forEach(function(element) {


                    if (element.hasOwnProperty("free_steel")) {
                        if (params[0].activeSteel.id == element.steel_id) {

                            if (params[0].shape == "Plat") {
                                if (params[0].length == element.length &&
                                    params[0].width == element.width &&
                                    params[0].thickness == element.thickness) {
                                    element.pieces += params[0].amount
                                    elementFound = 1;
                                }
                            } else if (params[0].shape == "Rond") {
                                if (params[0].length == element.length &&
                                    params[0].radius == element.radius) {
                                    element.pieces += params[0].amount
                                    elementFound = 1;
                                }
                            }

                        }
                    }

                }, params);
            }

            if (!elementFound) {
                let object = {
                    id: this.guestOrderLines.length + 1,
                    free_steel: true,
                    product_id: null,
                    category: {
                        name: this.category.title
                    },
                    category_id: this.category.id,
                    order_offer: 0,
                    article: null,
                    steel: {
                        name: this.activeSteel.name
                    },
                    steel_id: this.activeSteel.id,
                    steel_name: this.activeSteel.name,
                    steel_type: this.activeSteel.type,
                    pieces: this.amount,
                    price_per_piece: null,
                    shape: {
                        name: this.shape
                    },
                    shape_code: this.shape,
                    length: this.length,
                    width: this.width,
                    thickness: this.thickness,
                    radius: this.radius
                };

                window.incrementShoppingCart();

                this.guestOrderLines.push(object);
            }

            this.$awn.success("Uw product is toegevoegd aan de winkelwagen!");
            this.saveGuestShoppingCart();
        },
        setOfferteAvailable: function() {
            this.fileUploaded = true;
        },
        saveGuestShoppingCart: function() {
            localStorage.setItem('guestShoppingcart', JSON.stringify(this.guestOrderLines));
            $("#guestShoppingcart").val(localStorage.getItem('guestShoppingcart'));
        },
    },
    computed: {
        offerteAvailable: function() {
            if (this.fileUploaded) {
                return true;
            }

            if (this.shape == "Plat") {
                if (this.length == null || this.width == null || this.thickness == null) {
                    return false;
                }
            } else {
                if (this.length == null || this.radius == null) {
                    return false;
                }
            }

            return true;
        },
        uploadAvailable: function() {
            return false
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/product/helpers/vrij/guest.js